export const base = 'https://us-central1-gyfr-mvp.cloudfunctions.net/firestoreApi';
export const appBase = 'https://connect.gyfrapp.com';

// export const base = 'http://127.0.0.1:5001/gyfr-mvp/us-central1/firestoreApi';
// export const appBase = 'http://localhost:3000';
